import React from 'react'
import React1 from '../../assets/react-logo.png'
import Graph from '../../assets/graphQL.png';
import AWS from '../../assets/amazon-logo.png';
import Flutter from '../../assets/flutter-logo.png'

const Mobileappsection = () => {
  return (
      <div className="my-10 flex flex-col bg-prime">
          <div className="font-prime text-2xl text-sec4 font-bold flex items-center justify-center mt-10">Mobile App Development</div>
            <div className="flex flex-row px-10 mt-10">
            <div className="text-6xl font-prime font-bold pr-32 w-1/2 ml-20 text-white">
                Utilize device hardware power for user-centric app creation.
            </div>
            <div className="flex flex-col gap-5 ml-10">
                {[
                    { text: 'Cross-platform or native iOS/Android frameworks' },
                    { text: 'Use the device power to build better user experiences' },
                    { text: 'Complex workflows, interactions, and visualizations' }
                ].map((item, index) => (
                    <div key={index} className="flex items-center">
                        <div className="bg-sec4 rounded-full w-12 h-12 flex items-center justify-center">
                            <div className="text-prime font-bold text-3xl"><ion-icon name="checkmark"></ion-icon></div>
                        </div>
                        <div className="font-prime font-medium text-xl ml-5 my-5 text-white">{item.text}</div>
                    </div>
                ))}
              </div>
        </div>
        <div className="grid grid-cols-4 px-10 my-20">
            <div className="flex flex-col w-1/4 ml-10">
                  <img src={React1} alt="" className='h-[84px] w-[84px]' />
                  <div className="flex items-center font-prime font-medium text-xl mt-3 ml-2 text-white">React</div>
            </div>
            <div className="flex flex-col w-1/4 ml-20">
                  <img src={AWS} alt="" className='h-[84px] w-[84px]' />
                  <div className="flex items-center font-prime font-medium text-xl mt-3 ml-2 text-white">AWS</div>
            </div>
            <div className="flex flex-col w-1/4 ml-40">
                  <img src={Flutter} alt="" className='h-[84px] w-[84px]' />
                  <div className="flex items-center font-prime font-medium text-xl mt-3 ml-2 text-white">Flutter</div>
            </div>
            <div className="flex flex-col w-1/4 ml-80">
                  <img src={Graph} alt="" className='h-[84px] w-[84px]' />
                  <div className="flex items-center font-prime font-medium text-xl mt-3 ml-2 text-white">GraphQL</div>
            </div>
        </div>
    </div>
  )
}

export default Mobileappsection
